import * as React from 'react';
import { cn } from '@/lib/utils';
import { Card, CardBody, CardContent } from '@/components/ui/card';

const GuideCustom = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-custom', 'flex flex-col gap-5', className)}
    {...props}
  />
));
GuideCustom.displayName = 'GuideCustom';

const GuideCustomHeader = React.forwardRef(({ className, ...props }, ref) => (
  <header
    ref={ref}
    className={cn('c-guide-custom-header', 'flex flex-wrap items-center gap-4', className)}
    {...props}
  />
));
GuideCustomHeader.displayName = 'GuideCustomHeader';

const GuideCustomTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn('mb-0 flex-grow text-base font-light text-neutral-darker [&>strong]:font-bold', className)}
    {...props}
  />
));
GuideCustomTitle.displayName = 'GuideCustomTitle';

const GuideCustomText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-0 text-sm font-light text-neutral-darker', className)}
    {...props}
  />
));
GuideCustomText.displayName = 'GuideCustomText';

const GuideCustomBody = React.forwardRef(({ className, children, ...props }, ref) => (
  <Card
    hover={false}
    ref={ref}
    className={cn('mb-0 text-sm font-light text-neutral-darker', className)}
    {...props}
  >
    <CardContent>
      <CardBody>{children}</CardBody>
    </CardContent>
  </Card>
));
GuideCustomBody.displayName = 'GuideCustomBody';

export { GuideCustom, GuideCustomHeader, GuideCustomTitle, GuideCustomBody, GuideCustomText };
